import VMAP from './vmap';

export default VMAP;